document.addEventListener('DOMContentLoaded', () => {
  const NEWSLETTER = {
    CLOSED: 'newsletterPopupClosed',
  };
  const POPUP_DELAY = 2000;
  const popupElement = document.getElementById('newsletter-popup');
  const popupForm = document.getElementById('popup-newsletter-form');
  const closePopupButton = document.getElementById('close-popup');

  const popupContent = popupElement?.querySelector('.popup-content');

  if (!popupElement || !popupForm || !closePopupButton || !popupContent) {
    return;
  }

  function showPopup() {
    popupElement.style.display = 'flex';
  }

  function hidePopup() {
    popupElement.style.display = 'none';
  }

  // Check if the popup should be shown
  if (!localStorage.getItem(NEWSLETTER.CLOSED)) {
    const currentPage = window.location.pathname;
    if (currentPage !== '/cart' && !currentPage.startsWith('/checkout')) {
      setTimeout(showPopup, POPUP_DELAY);
    }
  }

  closePopupButton.addEventListener('click', () => {
    hidePopup();
    localStorage.setItem(NEWSLETTER.CLOSED, true);
  });

  // Close the popup and update localStorage if clicking outside of the popup content
  document.addEventListener('click', function (event) {
    const clickedOutsidePopup = !popupContent.contains(event.target);
    if (
      popupElement.style.display === 'flex' &&
      clickedOutsidePopup &&
      event.target !== closePopupButton
    ) {
      hidePopup();
      localStorage.setItem(NEWSLETTER.CLOSED, true);
    }
  });

  popupForm.addEventListener('submit', () => {
    localStorage.setItem(NEWSLETTER.CLOSED, true);
    hidePopup();
  });
});
